import { useGetAssignedGroupsInfinite } from '@repo/api/group/useGetAssignedGroupsInfinite';
import { useInfiniteQueryResult } from '@repo/hooks/useInfiniteQueryResult';
import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useEffect, useState } from 'react';

import GradeGroupSection from '@/components/features/grades/GradeGroupSection';
import GradesEmptyState from '@/components/features/grades/GradesEmptyState';
import { Accordion } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { InfiniteScroll } from '@/components/ui/infinite-scroll';
import { Skeleton } from '@/components/ui/skeleton';
import { toasterMessageHandler } from '@/lib/toaster-message-handler';
import { useCredentials } from '@/store/auth-store';

export default function MyGradesPage() {
  const { id } = useCredentials();
  const [openGroups, setOpenGroups] = useState<string[]>([]);

  const { data, isLoading, isFetching, isSuccess, isError, error, fetchNextPage, hasNextPage, refetch } = useGetAssignedGroupsInfinite();

  const { data: groups, isEmpty } = useInfiniteQueryResult(data);

  useEffect(() => {
    if (isError) {
      toasterMessageHandler(baseErrorMessages, error, {
        action: (
          <Button
            size={'sm'}
            className={'ml-auto'}
            variant={'tertiary'}
            onClick={() => {
              void refetch();
            }}
          >
            Ponów
          </Button>
        ),
      });
    }
  }, [isError, error, refetch]);

  return (
    <div className={'base-direction-col'}>
      {isSuccess && isEmpty && <GradesEmptyState description="Nie jesteś przypisany do żadnej z grup" />}
      <Accordion type={'multiple'} value={openGroups} onValueChange={setOpenGroups} className={'w-full gap-3'}>
        {isLoading && (
          <>
            <Skeleton className={'h-20 w-full rounded-xl'} />
            <Skeleton className={'h-20 w-full rounded-xl'} />
            <Skeleton className={'h-20 w-full rounded-xl'} />
          </>
        )}
        {groups.map((group) => (
          <GradeGroupSection key={group.id} userId={id} group={group} isOpen={openGroups.includes(String(group.id))} />
        ))}
        <InfiniteScroll hasNextPage={hasNextPage} isLoading={isLoading} isFetching={isFetching} next={fetchNextPage} threshold={0.65} root={null}>
          {hasNextPage && !isError && <Skeleton className={'h-20 w-full rounded-xl'} />}
        </InfiniteScroll>
      </Accordion>
    </div>
  );
}
